import invoiceStatus from '../config/invoiceStatus'

export default {

  filters: {
    
    invoiceStatusToText (status) {
      
      let statusText = ""
      
      switch(status) {
        case invoiceStatus.pending:
          statusText = "Pending"
        break
        case invoiceStatus.confirmed:
          statusText = "Confirmed"
        break
        case invoiceStatus.approved:
          statusText = "Approved"
        break
        case invoiceStatus.cancelled:
          statusText = "Cancelled"
        break
        case invoiceStatus.shipped:
          statusText = "Shipped"
        break
        case invoiceStatus.delivered:
          statusText = "Delivered"
        break
      }

      return statusText

    }

  },

}
